module.exports = require("/Users/yvettezhang/Documents/FSA/practice/Portfolio/gatsby-site/src/utils/typography.js")


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-typography/.cache/typography.js
// module id = 370
// module chunks = 231608221292675